import { Link } from 'react-router-dom';
import LazyImage from '../../LazyImage';

const SpecialCardv2 = ({
    special,
    menuSlug,
    menuSpecials,
    singleSpecialView,
    setSelectedSpecialId
}) => {
    return (
        menuSpecials ? (
            <div
                className='headless-specials-card headless-specials-card-theme-v2'
                style={{
                    backgroundImage: `url(${special?.menuDisplayConfiguration?.image !=
                            '/images/default-special-card.jpg'
                            ? special?.menuDisplayConfiguration?.image
                            : 'https://range-headless.s3.amazonaws.com/specials-bg.jpg'
                        })`,
                }}
                onClick={() => {
                    if (!singleSpecialView) {
                        setSelectedSpecialId(special.id);
                    }
                }}
            >
                <div className='headless-specials-card-overlay'></div>
                <div className='headless-specials-card-info'>
                    <div className='headless-specials-title'>{special.name}</div>
                    {singleSpecialView && special?.menuDisplayConfiguration?.description && (
                        <div className='headless-specials-description'>{special.menuDisplayConfiguration.description}</div>
                    )}
                </div>
                {!singleSpecialView && (
                    <a role='button' className='headless-specials-button' aria-label='View Special'>
                        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'><path d='M443.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l377.4 0L244.7 420.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l176-176z' /></svg>
                    </a>
                )}
            </div>
        ) : (
            <Link to={`/shop/${menuSlug}/special/${special.id}/`} reloadDocument>
                <LazyImage
                    classnames='headless-specials-card headless-specials-card-theme-v2'
                    styles={{
                        backgroundImage: `url(${special.menuDisplayConfiguration.image !=
                                '/images/default-special-card.jpg'
                                ? special.menuDisplayConfiguration.image
                                : 'https://range-headless.s3.amazonaws.com/specials-bg.jpg'
                            })`,
                    }}
                >
                    <div className='headless-specials-card-overlay'></div>
                    <div className='headless-specials-title'>{special.name}</div>
                    <div className='headless-specials-button-wrapper'>
                        <button className='headless-specials-button' aria-label='View Special'>
                            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'><path d='M443.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l377.4 0L244.7 420.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l176-176z' /></svg>
                        </button>
                    </div>
                </LazyImage>
            </Link>
        )
    );
};

export default SpecialCardv2;
